import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useStoreOptinTriggers = (optinId: number) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleTriggersEnum[]>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    `/api/dashboard/customer/digital-store/item-optin/${optinId}/automation-rule-triggers`,
    fetcher,
    {},
    !!user,
  )
}
